import {CloseButton, Flex} from '@chakra-ui/react';
import React from 'react';
import {useTags} from '../../../hooks/api/tags';
import {ObjectId} from 'bson';
import {loadingTextsFor} from './utils';
import {FilterSelect} from './FilterSelect';

const TagFilterLoadingTexts = loadingTextsFor('tags');
const filterSelectionOptions = {
  include: {label: 'include any of', value: 'include any of'},
};

export const TagsFilterControl = ({
  selectedTags,
  setSelectedTags,
  onRemove,
}: {
  selectedTags: ObjectId[];
  setSelectedTags: (selectedTags: ObjectId[]) => void;
  onRemove?: () => void;
}) => {
  const tags = useTags({});
  const tagOptions = React.useMemo(
    () =>
      tags.data?.map((tag) => ({
        value: tag._id,
        label: tag.name,
      })),
    [tags.data]
  );

  const selectedTagOptions = React.useMemo(
    () =>
      tagOptions?.filter((tagOption) =>
        selectedTags.find((id) => id.equals(tagOption.value))
      ),
    [selectedTags, tagOptions]
  );

  if (!tagOptions?.length) {
    return null;
  }

  return (
    <Flex flex={2} gap="2" alignItems="center">
      <Flex alignItems="center" alignSelf="flex-start">
        <FilterSelect
          variant="operator"
          options={Object.values(filterSelectionOptions)}
          value={filterSelectionOptions.include}
        />
      </Flex>

      <FilterSelect
        noOptionsMessage={() => TagFilterLoadingTexts[tags.status]}
        options={tagOptions}
        isMulti
        onChange={(values) => setSelectedTags(values.map((v) => v.value))}
        value={selectedTagOptions}
      />
      <CloseButton onClick={onRemove} />
    </Flex>
  );
};
